import { useQuery } from 'react-query';
import NewsletterService from '~/api/services/newsletter';
import MilkFixedService from '~/api/services/milkFixedPrice';
import { onError } from '~/utils/helpers';
import { FAT_PROTEIN_SLUG, MILK_FIXED_SLUG, MILK_STOCK_EXCHANGE } from '~/Constants';

const getNewsLetterList = (data?) => useQuery(
  'newsletter-list',
  () => NewsletterService.getNewsletterIndex(data),
  {
    cacheTime: 60_000,
    enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const getNewsLetterOptions = () => useQuery(
  'newsletter-options',
  () => NewsletterService.getNewsletterOptions(),
  {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const getTradingSlotsOptions = (type, data?) => useQuery(
  [`trading-slots-${type}-options-${data?.search}`],
  async () => {
    let response
    switch (type) {
      case MILK_FIXED_SLUG:
        response = await MilkFixedService.getMilkFixedPriceList(data)
        break;
      case FAT_PROTEIN_SLUG:
        response = await MilkFixedService.getFatProteinSlotsList(data)
        break;
      case MILK_STOCK_EXCHANGE:
        response = await MilkFixedService.getStockExchangeSlotsList(data)
        break;
      default:
    }
    return response.data
  },
  {
    // enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    structuralSharing: false,
    keepPreviousData: true
  }
)

const getRecipients = (filteredRecipients) => useQuery(
  'get-recipients',
  () => NewsletterService.getNewsletterRecipients(filteredRecipients),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data
    }
  }
)

const showNewsletter = (id) => useQuery(
  'show-newsletter',
  () => NewsletterService.showNewsletter(id),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getNewsletterRecipientsById = (id) => useQuery(
  ['get-newsletter-recipients', id],
  () => NewsletterService.getNewsletterRecipientsById(id),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

export const NewsletterQuery = {
  getNewsLetterList,
  getRecipients,
  getNewsLetterOptions,
  getTradingSlotsOptions,
  showNewsletter,
  getNewsletterRecipientsById
};
